/** 모바일 카드 스택을 누가 구동하나. replay = motion 이 CSS 연출 재현, fade = 이동 없이 페이드, null = stats.css */
export type StackMode = 'replay' | 'fade' | null;

export function resolveStackMode(
  isMobile: boolean,
  reduced: boolean,
  hasScrollTimeline: boolean,
): StackMode {
  if (!isMobile) return null; // 데스크탑은 stats.css 진입 애니메이션
  if (reduced) return 'fade';
  return hasScrollTimeline ? null : 'replay'; // 지원 브라우저는 CSS scroll-driven 그대로
}
